var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _path27, _mask5, _g5, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _mask6, _g6, _path35, _mask7, _g7, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrocentrifugeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 312,
    fill: "none",
    viewBox: "0 0 160 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    fillRule: "evenodd",
    d: "M144.352 272.986l-3.693 34.239-19.428-156.387h35.956l-12.835 122.148zm-127.649-4.824L20 308l19.824-157.074H3.78l12.923 117.236z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F9F9F",
    d: "M140.747 307.316a513.249 513.249 0 0 1-60.132 3.772c-22.066 0-42.373-1.404-60.395-3.596v-38.243l120.527-.175v38.242z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M5.275 158.644s16 44.47 17.142 56.487c.88 8.946-1.582 42.979-2.9 60.082-.44 5.965 2.988 11.403 8.351 12.982a187.098 187.098 0 0 0 52.66 7.806c21.274 0 39.384-3.684 53.098-7.719 5.539-1.666 9.143-7.455 8.44-13.595-.703-6.052-1.407-13.069-2.198-20.963-1.67-16.314-2.989-33.769-1.846-38.681 2.286-9.824 15.56-56.486 15.56-56.486l-148.307.087z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M16.703 172.766l126.682-.088c-.088 0-63.121 95.431-126.682.088z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M157.011 150.838c0 3.772-2.549 7.368-7.121 10.613-12.22 8.596-38.945 14.648-69.978 14.648-30.945 0-57.67-5.964-69.89-14.56-4.571-3.245-7.12-6.754-7.12-10.526 0-13.858 34.46-25.173 77.01-25.173 42.637-.175 77.099 11.052 77.099 24.998z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D0E0E",
    d: "M149.89 161.364c-12.22 8.595-38.945 14.648-69.978 14.648-30.945 0-57.67-5.965-69.89-14.561 12.22-8.595 38.945-14.648 69.89-14.648 31.033 0 57.758 5.965 69.978 14.561z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#828383",
    fillRule: "evenodd",
    d: "M133.251 133.575c-13.497-4.866-32.316-7.91-53.246-7.866H80c-20.885 0-39.705 3.086-53.213 7.985-6.765 2.454-12.066 5.314-15.629 8.362-3.572 3.056-5.141 6.064-5.141 8.87 0 3.039 1.808 6.335 6.055 9.594l.008.007.008.006c5.655 4.416 14.923 8.3 26.767 11.07 11.79 2.758 25.927 4.364 41.145 4.364 15.216 0 29.351-1.627 41.141-4.406 11.834-2.79 21.099-6.692 26.758-11.106 4.212-3.381 6.085-6.683 6.085-9.705 0-2.807-1.565-5.808-5.129-8.853-3.554-3.038-8.845-5.885-15.604-8.322zm18.853 4.52c4.17 3.564 6.88 7.832 6.88 12.655 0 5.221-3.223 9.809-7.969 13.616l-.013.01-.013.01c-6.474 5.056-16.544 9.176-28.701 12.041-12.21 2.878-26.734 4.54-42.288 4.54-15.55 0-30.074-1.639-42.283-4.495-12.151-2.842-22.22-6.937-28.698-11.992-4.891-3.756-8.002-8.352-8.002-13.554 0-4.825 2.716-9.098 6.89-12.669 4.186-3.58 10.094-6.695 17.175-9.263 14.183-5.144 33.604-11.285 54.916-11.285 21.354-.044 40.776 6.052 54.949 11.163 7.076 2.551 12.978 5.652 17.157 9.223z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M80 186.186c-30.945 0-58.462-7.807-71.736-20.349C2.814 160.662 0 154.96 0 148.908c0-20.963 35.165-37.365 80-37.453 44.835 0 80 16.402 80 37.278 0 6.052-2.813 11.753-8.264 16.928-13.274 12.718-40.791 20.525-71.736 20.525zm0-67.187c-43.692 0-72.967 15.437-72.967 29.909 0 3.772 2.022 7.631 5.89 11.315 11.868 11.227 38.242 18.507 67.165 18.507 28.923 0 55.209-7.367 67.165-18.595 3.868-3.683 5.89-7.455 5.89-11.314-.176-14.473-29.451-29.822-73.143-29.822z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M89.12 155.7c-.3.9-1 1.6-2 2.3-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1-1-.7-1.7-1.4-2-2.3-.9-2.5 3.4-4.7 9.5-4.7 6.2 0 10.4 2.2 9.5 4.7z",
    opacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M87.219 158c-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1 1.7-.9 4.4-1.5 7.5-1.5 3.1 0 5.7.6 7.5 1.5z",
    opacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M44.12 164.7c-.3.9-1 1.6-2 2.3-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1-1-.7-1.7-1.4-2-2.3-.9-2.5 3.4-4.7 9.5-4.7 6.2 0 10.4 2.2 9.5 4.7z",
    opacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M42.219 167c-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1 1.7-.9 4.4-1.5 7.5-1.5 3.1 0 5.7.6 7.5 1.5z",
    opacity: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M65.12 158.7c-.3.9-1 1.6-2 2.3-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1-1-.7-1.7-1.4-2-2.3-.9-2.5 3.4-4.7 9.5-4.7 6.2 0 10.4 2.2 9.5 4.7z",
    opacity: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M63.219 161c-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1 1.7-.9 4.4-1.5 7.5-1.5 3.1 0 5.7.6 7.5 1.5z",
    opacity: 0.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M115.119 158.7c-.3.9-1 1.6-2 2.3-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1-1-.7-1.7-1.4-2-2.3-.9-2.5 3.4-4.7 9.5-4.7 6.2 0 10.4 2.2 9.5 4.7z",
    opacity: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M113.219 161c-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1 1.7-.9 4.4-1.5 7.5-1.5 3.1 0 5.7.6 7.5 1.5z",
    opacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M137.119 163.7c-.3.9-1 1.6-2 2.3-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1-1-.7-1.7-1.4-2-2.3-.9-2.5 3.4-4.7 9.5-4.7 6.2 0 10.4 2.2 9.5 4.7z",
    opacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M135.219 166c-1.8 1.2-4.6 2.1-7.5 2.1-2.8 0-5.6-.8-7.5-2.1 1.7-.9 4.4-1.5 7.5-1.5 3.1 0 5.7.6 7.5 1.5z",
    opacity: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M155.077 141.014c0-17.367-33.582-31.4-75.077-31.4S4.923 123.735 4.923 141.102v8.42c0 17.367 33.582 31.401 75.077 31.401 41.407 0 75.077-14.034 75.077-31.401v-8.508z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M80 172.503c41.495 0 75.077-14.122 75.077-31.489s-33.582-31.4-75.077-31.4-75.077 14.121-75.077 31.488c0 17.367 33.582 31.401 75.077 31.401zm0-41.4c13.099 0 23.736 4.473 23.736 9.911 0 5.526-10.637 10-23.736 10s-23.736-4.474-23.736-9.912c0-5.438 10.637-9.999 23.736-9.999z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M144 130.577C144 115.841 115.341 104 80 104c-35.34 0-64 11.929-64 26.577v6.929c0 14.736 28.66 26.577 64 26.577 35.341 0 64-11.929 64-26.577v-6.929z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M80 157.241c35.341 0 64-11.929 64-26.576 0-14.648-28.659-26.577-64-26.577-35.34 0-64 11.929-64 26.577 0 14.647 28.66 26.576 64 26.576z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M103.736 118.034c0-5.789-10.637-10.525-23.736-10.525s-23.736 4.736-23.736 10.525v8.42c0 5.789 10.637 10.526 23.736 10.526s23.736-4.737 23.736-10.526v-8.42z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 128.559c13.11 0 23.736-4.712 23.736-10.525 0-5.813-10.627-10.525-23.736-10.525-13.11 0-23.736 4.712-23.736 10.525 0 5.813 10.627 10.525 23.736 10.525zM56.264 184.783c5.362 1.052 13.274 2.192 22.857 2.28 10.462.088 19.077-1.14 24.703-2.28v-14.21c-5.802 1.053-14.066 2.105-24.176 2.105-9.67 0-17.67-1.052-23.384-2.105v14.21z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.264 184.783c5.362 1.052 13.274 2.192 22.857 2.28 10.462.088 19.077-1.14 24.703-2.28v-14.21c-5.802 1.053-14.066 2.105-24.176 2.105-9.67 0-17.67-1.052-23.384-2.105v14.21zM23.253 208.878c-.945-6.507 5.577-11.128 10.776-7.733 9.924 6.507 19.944 17.504 44.423 17.504 24.479 0 33.27-10.337 43.478-16.749 4.821-3.112 12.785.943 12.501 6.978v.849c-.094 3.866 1.677 45.888 3.284 61.26.378 3.772-1.796 7.261-5.104 8.204-13.327 4.055-31.285 7.922-52.741 7.922s-39.414-3.773-52.647-7.828c-3.213-1.037-5.387-4.337-5.104-7.921.662-9.336 1.229-16.88 1.607-22.255.945-14.617.378-34.196 0-37.496-.189-.755-.284-1.698-.473-2.735z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#54BCE3",
    d: "M135.919 259.056c-11.72 5.941-39.13 18.295-61.531 11.411-3.876-1.132-16.068-4.904-17.203-12.448-.661-4.715 3.309-8.016 2.174-9.902-1.228-2.263-9.073-1.509-36.011 10.845-.378 4.904-.85 11.128-1.323 18.389-.284 3.678 1.89 6.978 5.104 7.922 13.232 4.055 31.285 7.827 52.646 7.827 21.456 0 39.414-3.867 52.741-7.922 3.309-1.037 5.483-4.526 5.104-8.204-.378-4.432-1.039-10.939-1.701-17.918z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 9,
    height: 18,
    x: 115,
    y: 228,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M115 228.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-16.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M115 228.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M115 237.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M115 237.375c0-.207.224-.375.5-.375s.5.168.5.375v8.25c0 .207-.224.375-.5.375s-.5-.168-.5-.375v-8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M116 245h7.625c.207 0 .375.224.375.5s-.168.5-.375.5H115l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M123.5 246c-.276 0-.5-.187-.5-.417v-9.166c0-.23.224-.417.5-.417s.5.187.5.417v9.166c0 .23-.224.417-.5.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M115 237.375c-1.5-.375.168-.375.375-.375H124l-1 1h-7c-.207 0-1-.418-1-.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M115 228.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M115 227.625c0-.23.224-.417.5-.417s.5.187.5.417V237h-1v-9.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M116 236h7c.207 0 1 .418 1 .625a.375.375 0 0 1-.375.375H115l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M123.5 237h-.5v-9.583c0-.23.224-.417.5-.417s.5.187.5.417V237h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M115 228.5c0-.276.168-.5.375-.5H124l-1 1h-7.625c-.207 0-.375-.224-.375-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M116.5 233.121l3.039-2.871v1.629l-3.039 2.871v-1.629zm6 0l-2.961-2.871v1.629l2.961 2.871v-1.629zM122.5 240.879l-3.039 2.871v-1.629l3.039-2.871v1.629zm-6 0l2.961 2.871v-1.629l-2.961-2.871v1.629z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 9,
    height: 18,
    x: 74,
    y: 250,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M74 250.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-16.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M74 250.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M74 259.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M74 259.375c0-.207.224-.375.5-.375s.5.168.5.375v8.25c0 .207-.224.375-.5.375s-.5-.168-.5-.375v-8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M75 267h7.625c.207 0 .375.224.375.5s-.168.5-.375.5H74l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M82.5 268c-.276 0-.5-.187-.5-.417v-9.166c0-.23.224-.417.5-.417s.5.187.5.417v9.166c0 .23-.224.417-.5.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M74 259.375c-1.5-.375.168-.375.375-.375H83l-1 1h-7c-.207 0-1-.418-1-.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE8",
    d: "M74 250.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M74 249.625c0-.23.224-.417.5-.417s.5.187.5.417V259h-1v-9.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M75 258h7c.207 0 1 .418 1 .625a.375.375 0 0 1-.375.375H74l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68B1CC",
    d: "M82.5 259H82v-9.583c0-.23.224-.417.5-.417s.5.187.5.417V259h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9E1F5",
    d: "M74 250.5c0-.276.168-.5.375-.5H83l-1 1h-7.625c-.207 0-.375-.224-.375-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M75.5 255.121l3.039-2.871v1.629L75.5 256.75v-1.629zm6 0l-2.961-2.871v1.629l2.961 2.871v-1.629zM81.5 262.879l-3.039 2.871v-1.629l3.039-2.871v1.629zm-6 0l2.961 2.871v-1.629L75.5 261.25v1.629z",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 78,
    height: 18,
    x: 36,
    y: 228,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4873E2",
    d: "M36 228h78v18H36z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E4BBF",
    d: "M36 228h77v18H36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M71 247l23.5-23.5H111L85.5 249 71 247zm38.5-19.5L90 247h3.5l19.5-19.5h-3.5z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B8B",
    d: "M31 245.5a.5.5 0 0 1 .5-.5h82a.5.5 0 0 1 0 1h-82a.5.5 0 0 1-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B8B",
    d: "M113 224.5a.5.5 0 0 1 1 0v21a.5.5 0 0 1-1 0v-21z"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 37,
    height: 18,
    x: 36,
    y: 250,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4873E2",
    d: "M36 250h37v18H36z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E4BBF",
    d: "M36 250h77v18H36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M47 269l23.5-23.5H87L61.5 271 47 269zm38.5-19.5L66 269h3.5L89 249.5h-3.5z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B8B",
    d: "M34 267.5a.5.5 0 0 1 .5-.5h38a.5.5 0 0 1 0 1h-38a.5.5 0 0 1-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B8B",
    d: "M72 247.5a.5.5 0 0 1 1 0v20a.5.5 0 0 1-1 0v-20z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.078 255c.7 0 1.053-.275 1.053-.83 0-.518-.273-.751-.995-.839-.507-.063-.691-.196-.691-.48 0-.288.224-.446.633-.446.414 0 .612.158.612.488h.397c0-.555-.335-.83-.995-.83-.674 0-1.04.283-1.04.826 0 .488.256.709.943.797.55.071.744.212.744.517 0 .3-.22.455-.656.455-.453 0-.687-.171-.687-.513H38c0 .571.365.855 1.078.855zM41.593 255c.546 0 .885-.234.916-.693h-.374c-.027.234-.207.376-.55.376-.406 0-.59-.192-.59-.613v-.096h1.532v-.313c0-.593-.34-.914-.96-.914-.62 0-.96.321-.96.914v.425c0 .593.348.914.986.914zm-.598-1.331c0-.413.18-.605.58-.605.397 0 .577.192.577.605h-1.157zM43.825 254.95h.352v-.317h-.26c-.26 0-.326-.071-.326-.351v-1.185h.56v-.3h-.56v-.568h-.347l-.031.568h-.4v.3h.391v1.181c0 .472.185.672.62.672zM46.486 254.95h.352v-.317h-.26c-.26 0-.326-.071-.326-.351v-1.185h.56v-.3h-.56v-.568h-.347l-.031.568h-.4v.3h.391v1.181c0 .472.185.672.62.672zM47.264 252.409h.423V252h-.423v.409zm.018 2.541h.387v-2.153h-.387v2.153zM48.4 254.95h.387v-1.389c.167-.334.356-.476.598-.476.238 0 .37.138.37.425v1.44h.387v-1.41c.168-.313.361-.455.6-.455.237 0 .369.138.369.425v1.44h.387v-1.469c0-.475-.25-.734-.704-.734a.816.816 0 0 0-.713.375c-.093-.246-.308-.375-.625-.375-.308 0-.533.121-.713.388l-.014-.338h-.33v2.153zM53.067 255c.546 0 .885-.234.915-.693h-.374c-.026.234-.207.376-.55.376-.405 0-.59-.192-.59-.613v-.096H54v-.313c0-.593-.339-.914-.96-.914-.62 0-.96.321-.96.914v.425c0 .593.349.914.987.914zm-.599-1.331c0-.413.18-.605.581-.605.396 0 .577.192.577.605h-1.158z"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 37,
    height: 18,
    x: 87,
    y: 250,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4873E2",
    d: "M87 250h37v18H87z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E4BBF",
    d: "M87 250h77v18H87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M59 269l23.5-23.5H99L73.5 271 59 269zm38.5-19.5L78 269h3.5l19.5-19.5h-3.5z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B8B",
    d: "M85 267.5a.5.5 0 0 1 .5-.5h38a.5.5 0 0 1 0 1h-38a.5.5 0 0 1-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B8B",
    d: "M123 247.5a.5.5 0 0 1 1 0v20a.5.5 0 0 1-1 0v-20z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.775 254.951h.348v-2.413h.775v-.336H89v.336h.775v2.413zM91.278 252.489h.37v-.396h-.37v.396zm.016 2.462h.34v-2.086h-.34v2.086zM92.273 254.951h.34v-1.346c.146-.323.312-.461.524-.461.209 0 .324.134.324.413v1.394h.34v-1.366c.146-.303.316-.441.525-.441.208 0 .324.134.324.413v1.394h.339v-1.423c0-.461-.22-.711-.617-.711-.255 0-.46.105-.625.364-.081-.239-.27-.364-.548-.364-.27 0-.467.117-.625.376l-.011-.328h-.29v2.086zM96.364 255c.478 0 .775-.226.802-.671h-.328c-.023.226-.181.364-.482.364-.355 0-.517-.186-.517-.595v-.093h1.342v-.303c0-.574-.297-.885-.84-.885-.544 0-.842.311-.842.885v.413c0 .574.305.885.865.885zm-.525-1.29c0-.4.158-.586.51-.586.346 0 .504.186.504.586H95.84zM98.73 254.951h.34V252h-.34v2.951zM100.474 255c.478 0 .775-.226.802-.671h-.328c-.023.226-.181.364-.482.364-.355 0-.517-.186-.517-.595v-.093h1.343v-.303c0-.574-.297-.885-.841-.885s-.841.311-.841.885v.413c0 .574.304.885.864.885zm-.525-1.29c0-.4.158-.586.509-.586.348 0 .506.186.506.586h-1.015zM101.905 254.951h.339v-1.795h.517v-.291h-.517v-.226c0-.251.077-.34.286-.34h.247V252h-.321c-.37 0-.551.214-.551.651v.214h-.363v.291h.363v1.795zM103.691 254.951H104v-.307h-.228c-.227 0-.285-.069-.285-.339v-1.149h.49v-.291h-.49v-.55h-.305l-.027.55h-.351v.291h.343v1.145c0 .456.162.65.544.65z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M101.114 233.374c0 1.22.61 2.294 1.57 2.677l-.185.464c-1.2-.478-1.885-1.775-1.885-3.141v-.323h.5v.323z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.512 233.59l-.432-1.616-1.08 1.185 1.512.431z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M104.738 236.064c.901-.499 1.599-1.497 1.599-2.69h.5c0 1.393-.814 2.55-1.857 3.128l-.242-.438z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104.859 235.314l-1.188 1.185 1.62.538-.432-1.723z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M103.671 230.5c-.568 0-1.162.286-1.679.699l-.312-.39c.562-.449 1.264-.809 1.991-.809.704 0 1.407.234 1.992.701l-.312.391a2.686 2.686 0 0 0-1.68-.592z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104.643 231.435l1.62.539-.324-1.724-1.296 1.185zM98 243h.91v-1.476h.493l.82 1.476h1.038l-.893-1.559c.516-.147.735-.523.735-1.176 0-.894-.401-1.265-1.415-1.265H98v4zm.91-2.229v-1.018h.681c.443 0 .601.147.601.512 0 .359-.158.506-.601.506h-.68zM101.843 243h.911v-1.4h.722c1.045 0 1.488-.382 1.488-1.294 0-.918-.443-1.306-1.488-1.306h-1.633v4zm.911-2.153v-1.094h.643c.462 0 .656.165.656.547s-.194.547-.656.547h-.643zM105.561 243h.862v-3.018L107.45 243h.613l1.026-3.018V243H110v-4h-1.348l-.875 2.612-.88-2.612h-1.336v4z"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 42,
    height: 14,
    x: 36,
    y: 272,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAAC48",
    d: "M36 273a1 1 0 0 1 1-1h40a1 1 0 0 1 1 1v12c0 .552-.464 1-1.016.998-28.901-.103-38.562-4.587-40.562-5.733A.866.866 0 0 1 36 279.5V273z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAAC48",
    d: "M36 273a1 1 0 0 1 1-1h40.018c.545 0 .99.433.998.978C78.068 276.159 78.21 286 78 286c-29.692 0-39.555-4.576-41.578-5.735A.866.866 0 0 1 36 279.5V273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD871A",
    d: "M77 273l1-1 .5 14.5-26-.5c-2.833-1.333-6.8-3.7 0-2.5 6.8 1.2 19.167 1.5 24.5 1.5v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD5A0",
    fillRule: "evenodd",
    d: "M36 272h42l-1 1H37v6.469c.193.143.525.339 1.04.575.67.305 1.61.659 2.867 1.04 2.516.762 6.283 1.624 11.666 2.421a.5.5 0 0 1-.146.99c-5.417-.803-9.234-1.674-11.81-2.454-1.287-.39-2.27-.759-2.992-1.088-.706-.322-1.204-.625-1.479-.899l-.146-.147V272z",
    clipRule: "evenodd"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.51 278.483v1.466H54v-3.743h1.427c.423 0 .754.104.993.313.241.209.362.486.362.831 0 .363-.118.643-.354.84-.234.196-.57.293-1.007.293h-.91zm0-.403h.917c.272 0 .481-.062.627-.185.145-.126.218-.305.218-.54a.692.692 0 0 0-.218-.535c-.146-.134-.345-.203-.598-.208h-.946v1.468zM59.13 279.674c-.191.217-.472.326-.842.326-.306 0-.54-.086-.701-.257-.16-.173-.24-.429-.242-.766v-1.81h.491v1.797c0 .422.177.632.532.632.375 0 .625-.135.749-.406v-2.023h.491v2.782h-.467l-.01-.275zM60.892 279.949H60.4V276h.492v3.949zM63.354 279.211a.34.34 0 0 0-.151-.298c-.1-.072-.274-.134-.524-.185a2.584 2.584 0 0 1-.592-.186.845.845 0 0 1-.324-.257.603.603 0 0 1-.104-.354c0-.228.1-.421.298-.579.2-.157.455-.236.765-.236.326 0 .59.081.792.244a.766.766 0 0 1 .305.625h-.494a.422.422 0 0 0-.173-.337.652.652 0 0 0-.43-.142c-.179 0-.319.038-.42.114a.35.35 0 0 0-.151.295c0 .115.047.202.14.26.094.058.264.114.508.167.246.053.445.116.598.19a.855.855 0 0 1 .337.267.628.628 0 0 1 .112.378.706.706 0 0 1-.308.599c-.206.149-.472.224-.8.224-.23 0-.434-.039-.611-.118a1.006 1.006 0 0 1-.417-.329.791.791 0 0 1-.149-.46h.492a.492.492 0 0 0 .196.38c.124.093.287.139.489.139a.814.814 0 0 0 .446-.108c.114-.074.17-.172.17-.293zM65.679 280c-.39 0-.707-.123-.951-.37-.245-.249-.367-.58-.367-.995v-.087c0-.276.054-.522.162-.738.11-.218.262-.388.457-.509.197-.124.41-.185.638-.185.374 0 .664.119.871.357.207.238.311.579.311 1.023v.198h-1.947c.007.274.09.496.247.666a.8.8 0 0 0 .605.252c.174 0 .321-.034.442-.103.12-.069.225-.159.316-.272l.3.226c-.241.358-.602.537-1.084.537zm-.061-2.494a.666.666 0 0 0-.5.211c-.134.139-.218.334-.25.586h1.44v-.036c-.014-.241-.081-.428-.201-.56a.624.624 0 0 0-.49-.201z"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 42,
    height: 14,
    x: 82,
    y: 272,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAAC48",
    d: "M124 273a1 1 0 0 0-1-1H83a1 1 0 0 0-1 1v12c0 .552.464 1 1.016.998 28.901-.103 38.562-4.587 40.562-5.733a.866.866 0 0 0 .422-.765V273z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAAC48",
    d: "M124 273a1 1 0 0 0-1-1H82.982a.995.995 0 0 0-.998.978C81.932 276.159 81.79 286 82 286c29.692 0 39.555-4.576 41.578-5.735a.866.866 0 0 0 .422-.765V273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD5A0",
    d: "M83 285l11.5-.3L96 286H82v-14h42l-1 1H83v12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD871A",
    fillRule: "evenodd",
    d: "M123 279.49V273l1-1v8.109l-.276.138c-4.084 2.042-9.158 4.25-29.194 5.452l-.06-.998c19.498-1.17 24.651-3.288 28.53-5.211z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 285.2,
    r: 0.5,
    fill: "#FFD5A0"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M94.459 278.211c-.464-.126-.802-.281-1.014-.465a.878.878 0 0 1-.316-.685c0-.306.13-.559.386-.759.26-.201.595-.302 1.008-.302.282 0 .532.052.752.155.221.103.392.246.512.428.122.182.183.38.183.596h-.543c0-.235-.079-.42-.237-.553-.157-.136-.38-.204-.667-.204-.266 0-.475.057-.625.169a.543.543 0 0 0-.222.462c0 .159.07.294.21.404.144.109.385.209.725.3.341.091.608.191.8.302.192.109.335.236.427.382.094.146.14.318.14.516 0 .316-.129.569-.388.76-.259.189-.605.283-1.039.283-.281 0-.544-.051-.788-.152a1.346 1.346 0 0 1-.566-.423.995.995 0 0 1-.197-.607h.543c0 .235.091.422.273.559.184.135.43.203.735.203.286 0 .504-.055.656-.166a.528.528 0 0 0 .229-.451.517.517 0 0 0-.212-.442c-.14-.105-.396-.208-.766-.31zM97.3 276.353v.7h.568v.383H97.3v1.794c0 .116.026.203.076.262.051.057.137.086.26.086.06 0 .142-.011.247-.033v.402c-.137.035-.27.053-.4.053-.232 0-.408-.067-.526-.201-.118-.133-.178-.323-.178-.569v-1.794h-.554v-.383h.554v-.7h.521zM100.36 279.947a.986.986 0 0 1-.073-.305 1.191 1.191 0 0 1-.868.358c-.3 0-.547-.08-.74-.241a.771.771 0 0 1-.287-.615c0-.301.12-.534.36-.7.242-.168.582-.251 1.02-.251h.506v-.228a.536.536 0 0 0-.163-.412c-.109-.103-.27-.155-.481-.155a.79.79 0 0 0-.468.134c-.126.089-.188.197-.188.324h-.524c0-.145.053-.284.16-.417.11-.136.255-.243.44-.321.185-.079.389-.118.61-.118.351 0 .626.084.825.251.199.166.303.395.31.688v1.331c0 .266.036.477.107.634v.043h-.546zm-.864-.377a.956.956 0 0 0 .464-.121.734.734 0 0 0 .318-.313v-.593h-.408c-.638 0-.957.177-.957.532 0 .155.054.276.163.364a.651.651 0 0 0 .42.131zM103.088 277.497a1.704 1.704 0 0 0-.256-.018c-.342 0-.573.138-.695.414v2.054h-.521v-2.894h.506l.009.335a.82.82 0 0 1 .726-.388c.102 0 .179.012.231.037v.46zM104.417 276.353v.7h.569v.383h-.569v1.794c0 .116.026.203.076.262.051.057.137.086.259.086.06 0 .143-.011.248-.033v.402c-.137.035-.27.053-.4.053-.233 0-.408-.067-.526-.201-.119-.133-.178-.323-.178-.569v-1.794h-.554v-.383h.554v-.7h.521z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrocentrifugeNew);
export default __webpack_public_path__ + "static/media/MicrocentrifugeNew.e0b8a97096fd6a6bd17f73331a5fab39.svg";
export { ForwardRef as ReactComponent };